export default __webpack_public_path__ + "static/media/CRRobustoOpen.a535f58e.jpg";